<div class="modal-body">
  <div class="text-center" *ngIf="!order && !isLoading && !isLegacyBooking">
    <!-- TODO: Translate this -->
    {{ 'Failed to load order for the booking' | translate }}
  </div>

  <div *ngIf="order || isLoading || isLegacyBooking">
    <div class="section">
      <p class="note">
        {{ 'CANCEL_UNTIL_MIDNIGHT_EXPLANATION' | translate }}
        {{ 'YOU_CAN_MODIFY_BOOKING_ANYTIME' | translate }}
      </p>
      <p class="note">
        {{ 'NO_SHOW_FEE_EXPLANATION' | translate }}
      </p>
      <div class="note">
        {{ 'PLEASE_READ_CANCELLATION_POLICY' | translate }}
        <a class="href" [href]="'https://luggagehero.com/terms-conditions/cancellation-policy'" target="_blank">{{
          'HERE' | translate
        }}</a
        >.
      </div>
    </div>

    <div class="section">
      <div class="headline">{{ 'WHY_ARE_YOU_CANCELING_SHORT' | translate }}</div>
      <div class="note">{{ 'WE_LIKE_TO_KNOW_WHY_PEOPLE_CANCEL' | translate }}</div>
    </div>

    <div class="section">
      <div dropdown autoClose="outsideClick" class="dropdown">
        <div class="booking-options href">
          <button id="cancelReasonDropdownToggle" class="btn btn-primary btn-cancel-reason" dropdownToggle>
            <span class="bi bi-caret-down-fill me-1"></span>
            <span class="cancel-reason-text">{{ selectedReason || ('CHOOSE_A_REASON' | translate) }}</span>
          </button>
        </div>
        <ul
          class="dropdown-menu cancel-reason-dropdown"
          id="cancelReasonsDropdown"
          *dropdownMenu
          role="menu"
          aria-labelledby="split-button"
        >
          <li *ngFor="let reason of cancelReasons">
            <a
              [id]="'selectCancelReason_' + reason.key"
              [attr.data-reason]="reason.key"
              class="href"
              (click)="selectReason(reason.key)"
              >{{ reason.value }}</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<lh-ticket-stub dock="bottom">
  <lh-simple-order-summary
    [headline]="'SUMMARY' | translate"
    [isPaid]="false"
    [isCanceled]="false"
    [order]="order"
    [isReadOnly]="true"
    [isInfoEnabled]="true"
    [dummyOrderLineCount]="1"
    *ngIf="!isLegacyBooking"
  ></lh-simple-order-summary>

  <div class="mt-4" *ngIf="isLegacyBooking"></div>

  <div class="sticky-footer">
    <button
      id="confirmCancelBooking"
      type="button"
      class="btn btn-block btn-warning btn-confirm"
      (click)="cancelBooking()"
      [disabled]="!isCancelAllowed"
    >
      <lh-shared-ui-spinner [visible]="isLoading"></lh-shared-ui-spinner>
      <span *ngIf="!isLoading">{{ 'CONFIRM_CANCEL_BOOKING' | translate }}</span>
      <div class="btn-overlay-inflate" *ngIf="isLoading || !isCancelAllowed"></div>
      <lh-shared-ui-tooltip
        *ngIf="!isLoading && !isCancelAllowed"
        [body]="'SELECT_CANCEL_REASON' | translate"
      ></lh-shared-ui-tooltip>
    </button>
  </div>

  <div class="non-sticky-footer">
    <div class="footnote">
      <span *ngIf="order?.total"
        >{{ 'CANCEL_YOU_WILL_BE_CHARGED' | translate }} {{ order.total | price: order.currency }}</span
      >
      <span *ngIf="!order?.total">
        {{ 'MODIFY_BOOKING_INSTEAD' | translate }}
        <a class="href" (click)="modifyBooking()">{{ 'MODIFY_BOOKING_CTA' | translate }}</a>
      </span>
    </div>
  </div>
</lh-ticket-stub>
